/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InPersonTrainingOutcome;

(function (InPersonTrainingOutcome) {
  InPersonTrainingOutcome["COMPLETED_SUCCESSFULLY"] = "completed_successfully";
  InPersonTrainingOutcome["ADDITIONAL_TRAINING_REQUIRED"] = "additional_training_required";
  InPersonTrainingOutcome["FOLLOW_UP_REQUIRED"] = "follow_up_required";
  InPersonTrainingOutcome["PORTAL_SUPPORT_REQUIRED"] = "portal_support_required";
  InPersonTrainingOutcome["PRODUCT_SUPPORT_REQUIRED"] = "product_support_required";
  InPersonTrainingOutcome["RESCHEDULED"] = "rescheduled";
  InPersonTrainingOutcome["CANCELLED"] = "cancelled";
})(InPersonTrainingOutcome || (InPersonTrainingOutcome = {}));